angular.module("ainapp")
    .controller("AddTenancyContractController", ["app.config", "$scope", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
        function (config, $scope, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Add Tenancy Contract";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Buildings = [];
            MainService.BuildingInDropdown().then(function (response) {
                $scope.Buildings = response.data;
            });

            $scope.VATs = [];
            MainService.VATsInDropdown().then(function (response) {
                $scope.VATs = response.data;
            });

            $scope.Banks = [];
            MainService.GetBankAccountList().then(function (response) {
                $scope.Banks = response.data;
            });


            $scope.loadVoucher = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.TenancyContractById($stateParams.VoucherId).then(function (response) {
                    if (response.data) {
                        $scope.UpdateDetails(response.data);
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("NetworkError");
                    $.LoadingOverlay("hide");
                })
            }

            $scope.getParticulars = function () {
                $scope.BuildingParticulars = [];
                MainService.GetAllFlatParticularsInContract($scope.Rental.FlatId).then(function (response) {
                    $scope.BuildingParticulars = response.data;
                    $scope.calculate();
                });
            }

            $scope.UpdateDetails = function (data) {

                $scope.Rental = data;

                $scope.Rental.Date = new Date($scope.Rental.Date);
                $scope.Rental.StartDate = new Date($scope.Rental.StartDate);
                $scope.Rental.ExpiryDate = new Date($scope.Rental.ExpiryDate);

                $scope.BuildingParticulars = $scope.Rental.TenancyContractPayments;
                $scope.PaymentTerms = $scope.Rental.TenancyContractPaymentTerms;

                angular.forEach($scope.PaymentTerms, function (e) {
                    e.PaymentDate = new Date(e.PaymentDate);
                })

                $scope.VoucherDocs = $scope.Rental.VoucherDocs;

                $scope.Flats = [];
                MainService.VacantFlatsByBuildingId($scope.Rental.BuildingId).then(function (response) {
                    if (response.data != null) {
                        $scope.Flats = response.data;
                    }
                    $scope.Flats.push($scope.Rental.Flat);
                });

            }

            $scope.RenewRental = function () {
                $scope.Rental.Id = 0;
                $scope.Rental.PreRefNo = $scope.Rental.ReferanceNo;
                MainService.GetNextTenancyContractNo().then(function (response) {
                    $scope.Rental.ReferanceNo = response.data;
                });

                var year = $scope.Rental.ExpiryDate.getFullYear();
                var month = $scope.Rental.ExpiryDate.getMonth();
                var day = $scope.Rental.ExpiryDate.getDate();
                $scope.Rental.StartDate = new Date(year, month, day);
                $scope.Rental.StartDate.setDate($scope.Rental.StartDate.getDate() + 1);

                $scope.Rental.ExpiryDate = new Date($scope.Rental.StartDate);
                $scope.Rental.ExpiryDate.setFullYear($scope.Rental.ExpiryDate.getFullYear() + 1);
                $scope.Rental.ExpiryDate.setDate($scope.Rental.ExpiryDate.getDate() - 1);

                $scope.Rental.Date = new Date();
                $scope.Rental.Type = "Renew";
                $scope.Rental.PaymentTerms = [];
                $scope.PaymentTerms = [];

                var particulats = [];
                angular.forEach($scope.BuildingParticulars, function (e) {
                    if (e.Particulars.LoadType == "Both") {
                        particulats.push(e);
                    }
                })
                $scope.BuildingParticulars = angular.copy(particulats);
                $scope.calculate();

            }


            $scope.init = function () {

                $scope.Load = false;
                $scope.Error = 0;
                $scope.ErrorText = "";
                $scope.ViewVal = 0;

                $scope.VoucherDocs = [];
                var tdate = new Date();
                var year = tdate.getFullYear();
                var month = tdate.getMonth();
                var day = tdate.getDate();
                var ndate = new Date(year + 1, month, day)

                $scope.Rental = {
                    Id: 0,
                    ReferanceNo: "",
                    Place: "",
                    Type: "New",
                    RentalType: "",
                    RentalType2: "",
                    ContractType: "Residential",
                    PurposeOfRent: "",
                    RentDuration: "",
                    StartDate: new Date(tdate),
                    ExpiryDate: new Date(ndate),
                    Date: new Date(),
                    RentType: "",
                    TotalAmount: 0,
                    TotalVat: 0,
                    SubTotal: 0,
                    OtherTotal: 0,
                    GrandTotal: 0,
                    NoOfPayments: 0,
                    AmountInWords: "",
                    PaymentMethod: "",
                    BondNo: "",
                    BondDate: new Date(),
                    GovernmentNo: "",
                    RentPropertyType: "",
                    Description: "",
                    LessorName: "",
                    LessorCardNo: "",
                    LessorDesignation: "",
                    LessorNationality: "",
                    LessorProfession: "",
                    LessorIDNo: "",
                    LessorAddress: "",
                    LessorTelephone: "",
                    LessorFax: "",
                    DateSelection: "First",
                    LessorPoBox: "",
                    LessorEmail: "",
                    FlatId: "",
                    BuildingId: "",
                    TenantId: "",
                    Tenantname: "",
                    TenantnameAR: "",
                    GLDateBy: "StartDate",
                    LessorId: "",
                    NoOfPtyRes: 0,
                    SecurityDeposit: 0,
                    TotalCommission: 0,
                    SpecialConditions: [],
                    RentalPayments: [],
                    IsVatAlreadyPaid: false,
                }

                if ($stateParams.VoucherId > 0) {

                    $scope.CP = {};
                    MainService.GetCompanyProfile().then(function (res) {
                        if (res.data != null) {
                            $scope.CP = res.data;
                        }
                    })

                    $scope.loadVoucher();

                } else {

                    MainService.GetNextTenancyContractNo().then(function (response) {
                        $scope.Rental.ReferanceNo = response.data;
                    });

                    $scope.Terms = [];
                    $scope.Conditions = [];
                    $scope.OtherPayments = [];

                    $scope.SelectedBuilding = {};
                    $scope.SelectedFlat = {};

                    $scope.CP = {};
                    MainService.GetCompanyProfile().then(function (res) {
                        if (res.data != null) {
                            var temp = res.data;
                            $scope.CP = res.data;

                            $scope.Rental.LessorName = temp.LessorName;
                            $scope.Rental.LessorCardNo = temp.LessorCardNo;
                            $scope.Rental.LessorDesignation = temp.LessorDesignation;
                            $scope.Rental.LessorNationality = temp.LessorNationality;
                            $scope.Rental.LessorProfession = temp.LessorProfession;
                            $scope.Rental.LessorIDNo = temp.LessorIDNo;
                            $scope.Rental.LessorAddress = temp.LessorAddress;
                            $scope.Rental.LessorTelephone = temp.LessorTelephone;
                            $scope.Rental.LessorFax = temp.LessorFax;
                            $scope.Rental.LessorPoBox = temp.LessorPoBox;
                            $scope.Rental.LessorEmail = temp.LessorEmail;
                        }
                    })

                }

            }
            $scope.init();



            $scope.ChangeLessor = function () {
                MainService.LessorsById($scope.Rental.LessorId).then(function (response) {
                    if (response.data != null) {
                        var data = response.data;
                        $scope.Rental.LessorName = data.Name;
                        $scope.Rental.LessorCardNo = data.CardNo;
                        $scope.Rental.LessorDesignation = data.Designation.Name;
                        $scope.Rental.LessorNationality = data.Nationality;
                        $scope.Rental.LessorProfession = data.profession;
                        $scope.Rental.LessorIDNo = data.IdNo;
                        $scope.Rental.LessorAddress = data.address;
                        $scope.Rental.LessorTelephone = data.Telephone;
                        $scope.Rental.LessorFax = data.Fax;
                        $scope.Rental.LessorEmail = data.Email;
                        $scope.Rental.LessorPoBox = data.PoBox;
                    }
                });
            }

            $scope.GetFlatsByApt = function () {

                $scope.Flats = [];
                MainService.VacantFlatsByBuildingId($scope.Rental.BuildingId).then(function (response) {
                    $scope.Flats = response.data;
                });

                //                if ($scope.Rental.BuildingId != null && $scope.Rental.BuildingId != "") {
                //                    MainService.FlatsInDropdownByAptIdForContract($scope.Rental.BuildingId).then(function (response) {
                //                        $scope.Flats = response.data;
                //                    });
                //                    MainService.BuildingsById($scope.Rental.BuildingId).then(function (response) {
                //                        $scope.SelectedBuilding = response.data;
                //                        $scope.Rental.LessorId = response.data.LessorId;
                //                        $scope.ChangeLessor();
                //                    });
                //                }else

                //$scope.GetBuildingPayments();
            }

            $scope.getFlatInfo = function () {
                MainService.FlatById($scope.Rental.FlatId).then(function (response) {
                    $scope.SelectedFlat = response.data;
                    if ($scope.Rental.Id <= 0) {
                        $scope.Rental.ContractType = response.data.FlatType;
                    }
                });

                $scope.getParticulars();
            }



            $scope.LessorAutocompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length == 0) {
                            var temp = {
                                value: "",
                                operator: "contains",
                                field: "Name",
                                ignoreCase: true
                            }
                            o.data.filter.filters.push(temp);
                        }
                        MainService.SuppliersInAutoComplete(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error($scope.NetworkErrorLan);
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.LessorAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.Rental.LessorId = data.Id;
                    $scope.Rental.Lessor = {};
                    $scope.Rental.Lessor.Name = data.Name;
                    $scope.Rental.Lessor.Id = data.Id;
                    $scope.Rental.Lessor.NameAr = data.NameAr;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.LessorAutocompleteDataSource
            };

            $scope.TenantAutocompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length == 0) {
                            var temp = {
                                value: "",
                                operator: "contains",
                                field: "Name",
                                ignoreCase: true
                            }
                            o.data.filter.filters.push(temp);
                        }
                        MainService.CustomerInAutoComplete(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error($scope.NetworkErrorLan);
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.TenantAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.Rental.TenantId = data.Id;
                    $scope.Rental.TenantName = data.Name;
                    $scope.Rental.TenantNameAr = data.NameAr;
                    $scope.Rental.TenantCardNo = data.CardNo;
                    $scope.Rental.TenantDesignation = data.Designation;
                    $scope.Rental.TenantBeneficiary = data.Beneficiary;
                    $scope.Rental.TenantNationality = data.Nationality;
                    $scope.Rental.TenantProfession = data.Profession;
                    $scope.Rental.TenantIDNo = data.IDNo;
                    $scope.Rental.TenantAddress = data.Address;
                    $scope.Rental.TenantMobileNo = data.MobileNo;
                    $scope.Rental.TenantTelephone = data.PhoneNo;
                    $scope.Rental.TenantFax = data.FaxNo;
                    $scope.Rental.TenantPoBox = data.POBox;
                    $scope.Rental.TenantEmail = data.Email;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.TenantAutocompleteDataSource
            };

            $scope.TenantAutocompleteOptionsAR = {
                valuePrimitive: true,
                dataValueField: "NameAr",
                dataTextField: "NameAr",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.Rental.TenantId = data.Id;
                    $scope.Rental.TenantName = data.Name;
                    $scope.Rental.TenantNameAr = data.NameAr;
                    $scope.Rental.TenantCardNo = data.CardNo;
                    $scope.Rental.TenantDesignation = data.Designation;
                    $scope.Rental.TenantBeneficiary = data.Beneficiary;
                    $scope.Rental.TenantNationality = data.Nationality;
                    $scope.Rental.TenantProfession = data.Profession;
                    $scope.Rental.TenantIDNo = data.IDNo;
                    $scope.Rental.TenantAddress = data.Address;
                    $scope.Rental.TenantMobileNo = data.MobileNo;
                    $scope.Rental.TenantTelephone = data.PhoneNo;
                    $scope.Rental.TenantFax = data.FaxNo;
                    $scope.Rental.TenantPoBox = data.POBox;
                    $scope.Rental.TenantEmail = data.Email;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.TenantAutocompleteDataSource
            };


            $scope.changeDate = function (data) {
                data.DueDate = data.PaymentDate;
                data.ChequeDate = data.PaymentDate;
            }

            $scope.SaveRental = function () {

                $scope.ErrorText = "";


                $scope.Rental.DateMonth = $scope.Rental.Date.getMonth() + 1;
                $scope.Rental.DateDay = $scope.Rental.Date.getDate();
                $scope.Rental.DateYear = $scope.Rental.Date.getFullYear();

                $scope.Rental.StartMonth = $scope.Rental.StartDate.getMonth() + 1;
                $scope.Rental.StartDay = $scope.Rental.StartDate.getDate();
                $scope.Rental.StartYear = $scope.Rental.StartDate.getFullYear();

                $scope.Rental.EndMonth = $scope.Rental.ExpiryDate.getMonth() + 1;
                $scope.Rental.EndDay = $scope.Rental.ExpiryDate.getDate();
                $scope.Rental.EndYear = $scope.Rental.ExpiryDate.getFullYear();

                var amount = 0;
                angular.forEach($scope.PaymentTerms, function (e) {
                    amount = amount + e.Amount;
                })


                if ($scope.Rental.Type == "") {
                    toastr.warning("Choose Rental Type");
                } else if ($scope.Rental.ContractType == "") {
                    toastr.warning("Choose Contract Type");
                } else if ($scope.Rental.Place == "") {
                    toastr.warning("Enter Contract Place");
                } else if ($scope.Rental.BuildingId == "") {
                    toastr.warning("Choose Building");
                } else if ($scope.Rental.FlatId == "") {
                    toastr.warning("Choose Flat");
                } else if ($scope.Rental.TenantId == "") {
                    toastr.warning("Choose Tenant");
                } else if ($scope.Rental.LessorId == "") {
                    toastr.warning("Choose Lessor");
                } else if ($scope.Rental.RentDuration == "") {
                    toastr.warning("Enter Rent Duration");
                } else if ($scope.Rental.RentType == "") {
                    toastr.warning("Enter Rent Type");
                } else if ($scope.Rental.AmountInWords == "") {
                    toastr.warning("Enter Amount In Words");
                } else if ($scope.Rental.PaymentMethod == "") {
                    toastr.warning("Choose Payment Method");
                } else if (amount != $scope.Rental.GrandTotal) {
                    toastr.warning("Payment Terms Not Matching With Grand Total");
                } else {

                    $scope.Rental.TenancyContractPayments = $scope.BuildingParticulars;
                    $scope.Rental.TenancyContractPaymentTerms = $scope.PaymentTerms;

                    $("#saveModal").modal("show");

                }
            }

            $scope.SaveWithConfirm = function () {
                $scope.VoucherDocs = $scope.VoucherDocs;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.AddTenancyContract($scope.Rental).then(function (response) {
                    if (response.data == "Success") {
                        $scope.Load = false;
                        $("#saveModal").modal("hide");
                        toastr.success("Success");
                        $state.go("TenancyContract");
                        $scope.init();
                    } else {
                        $scope.Load = false;
                        toastr.warning(response.data);
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error("Network Error");
                    $scope.Load = false;
                });
            }

            $scope.DeleteRental = function () { 

                if ($scope.IsValidFinYear == false) {
                    toastr.info("Operation Not Possible, Current Financial Year Closed.");
                } else {
                    $('#mymodal').modal('show');

                }

            }

            $scope.deleteWithConfirm = function () {
                $scope.Load = true;
                MainService.DeleteRental($scope.Rental.Id).then(function (response) {
                    if (response.data == true) {
                        $scope.Load = false;
                        toastr.success($scope.SuccessLan);
                        $('#mymodal').modal('hide');
                        $scope.init();
                    } else {
                        $scope.Load = false;
                        toastr.warning($scope.CannotdeleteOperationsfoundLan);
                    }
                }, function () {
                    toastr.error($scope.NetworkErrorLan);
                    $scope.Load = false;
                })
            }

            $scope.RemoveTerms = function (data) {
                var index = $scope.PaymentTerms.indexOf(data);
                $scope.PaymentTerms.splice(index, 1);

                if ($scope.PaymentTerms.length == 0) {
                    angular.forEach($scope.BuildingParticulars, function (e) {
                        e.IsSelected = false;
                        e.IsPaymentGenerated = false;
                        e.PaymentGenerated = 0;
                    })
                }
            }

            $scope.RemoveParticular = function (data) {
                var index = $scope.BuildingParticulars.indexOf(data);
                $scope.BuildingParticulars.splice(index, 1);
                $scope.calculate();
            }

            $scope.calculate = function () {

                $scope.Rental.SubTotal = 0;
                $scope.Rental.TotalVat = 0;
                $scope.Rental.GrandTotal = 0;

                angular.forEach($scope.BuildingParticulars, function (e) {

                    e.Amount = Math.round(e.Amount * 100) / 100;
                    e.TotalVat = 0;
                    e.TotalAmount = 0;

                    angular.forEach($scope.VATs, function (a) {
                        if (a.Id == e.VATId) {
                            e.VAT = a;
                        }
                    });

                    if (e.VAT.Value > 0) {

                        if (e.VatType != "Exclusive") {
                            e.TotalVat = (e.Amount * e.VAT.Value) / (100 + e.VAT.Value);
                            e.TotalVat = Math.round(e.TotalVat * 100) / 100;

                            e.TotalAmount = + e.Amount;
                        } else {
                            e.TotalVat = e.Amount * (e.VAT.Value / 100);
                            e.TotalVat = Math.round(e.TotalVat * 100) / 100;

                            e.TotalAmount = e.TotalVat + e.Amount;
                        }

                    } else {
                        e.TotalAmount = e.Amount;
                    }



                    $scope.Rental.SubTotal = $scope.Rental.SubTotal + e.Amount;
                    $scope.Rental.SubTotal = Math.round($scope.Rental.SubTotal * 100) / 100;
                    $scope.Rental.TotalVat = $scope.Rental.TotalVat + e.TotalVat;
                    $scope.Rental.TotalVat = Math.round($scope.Rental.TotalVat * 100) / 100;
                    $scope.Rental.GrandTotal = $scope.Rental.GrandTotal + e.TotalAmount;
                    $scope.Rental.GrandTotal = Math.round($scope.Rental.GrandTotal * 100) / 100;

                })

            }

            $scope.PaymentTerms = [];
            $scope.generatePayments = function () {
                $scope.genPayment = {
                    PaymentType: "Cheque",
                    ChequeNo: "",
                    NoOfCheques: 1,
                    ChequeStartDate: null,
                    PayeeBankId: "",
                    BankAccountId: "",
                };


                $("#paymentModal").modal("show");
            }

            $scope.savePayment = function () {
                var selected = false;
                var selectedType = false;
                angular.forEach($scope.BuildingParticulars, function (e) {
                    if ((e.PaymentGenerated != e.TotalAmount) && e.IsSelected) {
                        selected = true;

                        if (e.SelectionType != null && e.SelectionType != undefined && e.SelectionType != "") {
                            selectedType = true;
                        }
                    }

                })

                if (selected == false) {
                    toastr.warning("Select Payments");
                }
                else if (selectedType == false) {
                    toastr.warning("Select Payment Calc Type");
                } else if ($scope.genPayment.PaymentType == "Cheque" && $scope.genPayment.ChequeNo == "") {
                    toastr.warning("Enter Cheque No");
                } else if ($scope.genPayment.ChequeStartDate == null) {
                    toastr.warning("Enter Cheque/Payment Start Date");
                } else if ($scope.genPayment.PaymentType == "Cheque" && $scope.genPayment.PayeeBankId == "") {
                    toastr.warning("Select Payee Bank");
                } else if ($scope.genPayment.PaymentType == "Cheque" && $scope.genPayment.BankAccountId == "") {
                    toastr.warning("Select Receivable Bank");
                } else {

                    var remarks = "";

                    var t = 1;
                    var amount = 0;
                    angular.forEach($scope.BuildingParticulars, function (e) {
                        if ((e.PaymentGenerated != e.TotalAmount) && e.IsSelected) {
                            if (t != 1) {
                                remarks = remarks + ", ";
                            }
                            remarks = remarks + e.Particulars.Name + "(" + e.SelectionType + ")";
                            t = t + 1;

                            if (e.PaymentGenerated == undefined) {
                                e.PaymentGenerated = 0;
                            }

                            if (e.SelectionType == "With VAT") {
                                amount = amount + e.TotalAmount;
                                e.PaymentGenerated = e.PaymentGenerated + e.TotalAmount;
                            }
                            if (e.SelectionType == "Without VAT") {
                                amount = amount + e.Amount;
                                e.PaymentGenerated = e.PaymentGenerated + e.Amount;
                            }
                            if (e.SelectionType == "VAT Only") {
                                amount = amount + e.TotalVat;
                                e.PaymentGenerated = e.PaymentGenerated + e.TotalVat;
                            }


                        }
                    })


                    var totaldays = 0;
                    if ($scope.genPayment.NoOfCheques > 1) {

                        var date1 = $scope.Rental.StartDate;
                        var date2 = $scope.Rental.ExpiryDate;
                        var days = Math.round((date2 - date1) / (1000 * 60 * 60 * 24));
                        totaldays = days / $scope.genPayment.NoOfCheques;

                        amount = amount / $scope.genPayment.NoOfCheques;
                        amount = $scope.roundOffValue(amount);
                    }

                    var firstChque = $scope.genPayment.ChequeNo;
                    for (var i = 0; i < $scope.genPayment.NoOfCheques; i++) {

                        var firstDate = $scope.genPayment.ChequeStartDate;
                        if (i > 0) {
                            firstDate = new Date(firstDate.setDate(firstDate.getDate() + totaldays));
                        }
                        var inst = i + 1;


                        if ($scope.genPayment.PaymentType == "Cheque") {
                            if (i > 0) {
                                firstChque = parseInt(firstChque) + 1;
                            }
                        }

                        var temp = {
                            PaymentType: $scope.genPayment.PaymentType,
                            ChequeNo: angular.copy(firstChque),
                            PaymentDate: angular.copy(firstDate),
                            PayeeBankId: $scope.genPayment.PayeeBankId,
                            BankAccountId: $scope.genPayment.BankAccountId,
                            Remarks: $scope.genPayment.NoOfCheques > 1 ? remarks + " - Installment " + inst : remarks,
                            Amount: amount,
                        }

                        $scope.PaymentTerms.push(temp);

                    }




                    $("#paymentModal").modal("hide");

                }

            }


            /////////////////// Attachment /////////////////

            $scope.VoucherDocs = [];
            $scope.initAttachment = function () {
                $scope.VAttachment = {
                    ExpiryDate: null,
                    FileName: "",
                    FilePath: "",
                    Remarks: "",
                    IsActive: true,
                }
            }
            $scope.initAttachment();

            $scope.addAttachmentList = function () {
                if ($scope.VAttachment.FilePath == "") {
                    toastr.warning("Upload File");
                } else if ($scope.VAttachment.FileName == "") {
                    toastr.warning("Enter File Name");
                } else {
                    $scope.VoucherDocs.push($scope.VAttachment);
                    $scope.initAttachment();
                }
            }

            $scope.removeAttachmentRow = function (data) {
                data.IsActive = false;
            }

            // file upload
            $scope.files = [];
            $scope.getFileDetails = function (e) {
                $scope.files = [];
                $scope.$apply(function () {
                    for (var i = 0; i < e.files.length; i++) {
                        $scope.files.push(e.files[i]);
                    }
                });
                $scope.Load = true;
                $scope.uploadFiles();
            };
            $scope.remove = function (file) {
                var index = $scope.files.indexOf(file);
                $scope.files.splice(index, 1);
            };
            $scope.uploadFiles = function () {
                var data = new FormData();
                for (var i in $scope.files) {
                    data.append("uploadedFile", $scope.files[i]);
                }
                var objXhr = new XMLHttpRequest();
                objXhr.onreadystatechange = function () {
                    if (objXhr.readyState == XMLHttpRequest.DONE) {
                        if (objXhr.responseText != null && objXhr.responseText != "") {
                            $scope.VAttachment.FilePath = objXhr.responseText;
                            if ($scope.VAttachment.FilePath.includes("error")) {
                                $scope.VAttachment.FilePath = "";
                                toastr.error($scope.LanguageData.UploadError);
                            } else {
                                $scope.VAttachment.FilePath = objXhr.responseText;
                                toastr.success($scope.LanguageData.FileUploaded);
                            }
                        } else { }
                    }
                };
                // objXhr.addEventListener("progress", updateProgress, false);
                objXhr.addEventListener("load", transferComplete, false);
                if ($scope.files.length > 0) {
                    toastr.info($scope.LanguageData.FileUploadingPleaseWait);
                    objXhr.open("POST", config.basePath + "UploadFiles");
                    objXhr.send(data);
                } else {
                    toastr.error($scope.LanguageData.UploadError);
                }
            };
            //function updateProgress(e) {
            //    if (e.lengthComputable) {
            //        document.getElementById('pro').setAttribute('value', e.loaded);
            //        document.getElementById('pro').setAttribute('max', e.total);
            //    }
            //}
            function transferComplete(e) {
                $scope.Load = false;
            }


            $scope.handleFileSelect = function (evt, bp) {
                var file = evt.target.files[0]; // use target not currentTarget
                if (!file) return;

                var reader = new FileReader();
                reader.onload = function (e) {
                    $scope.$apply(function () {
                        $scope.myImage = e.target.result;
                        bp.Photo = e.target.result; // store base64 in the row object
                    });
                };
                reader.readAsDataURL(file);
            };



        }]);
